import { Component } from 'react';
import { FaRedo, FaExclamationTriangle } from 'react-icons/fa';

const BLOCK = 'LStudio__app_error';

export class AppErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = { error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        this.setState({ info });
        this.props.onError?.(error, info);
        console.error('[ErrorBoundary]', error, info);
    }

    onReset = () => {
        this.setState({ error: null, info: null });
        this.props.onReset?.();
    };

    render() {

        const { error, info } = this.state;
        const { children, fallback, isDetailed = false } = this.props;

        if (!error) return children;

        if (fallback) return fallback(error, this.onReset);

        return (
            <div className={BLOCK} role="alert">

                <span className={`${BLOCK}__icon`}><FaExclamationTriangle /></span>

                <h2 className={`${BLOCK}__title`}>Algo salió mal</h2>

                <p className={`${BLOCK}__text`}>
                    La pantalla no se pudo mostrar. Podés reintentar; si vuelve a pasar,
                    avisanos.
                </p>

                {
                    isDetailed && (
                        <details className={`${BLOCK}__details`}>
                            <summary>Detalle técnico</summary>
                            <pre>{error.toString()}{info?.componentStack}</pre>
                        </details>
                    )
                }

                <div className={`${BLOCK}__actions`}>
                    <button type="button" className={`${BLOCK}__button`} onClick={this.onReset}>
                        <FaRedo /> Reintentar
                    </button>
                    <button type="button" className={`${BLOCK}__button ${BLOCK}__button--ghost`}
                        onClick={() => window.location.reload()} >
                        Recargar la página
                    </button>
                </div>
            </div>
        );
    }
}
